import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { CustomerMembership, CustomerMembershipCustomer } from '../../../../../../../../../../models/membership';
import { OrganizationConfigService } from '../../../../../../../../../../services/organization-config/organization-config.service';
import { CustomerService } from '../../../../../../../../../../services/customer/customer.service';
import { Roster } from '../../../../../../../../../../models/event-type';
import { propExists } from '../../../../../../../../../../utils';
import { EventTypeService } from '../../../../../../../../../../services/event-type/event-type.service';


@Component({
  selector: 'app-change-customer-membership-roster',
  templateUrl: './change-customer-membership-roster.component.html',
  styleUrls: ['./change-customer-membership-roster.component.css']
})
export class ChangeCustomerMembershipRosterComponent implements OnInit, OnDestroy {

  @Input() membership: CustomerMembership;
  @Input() savedCallback: (successMessage: string) => undefined;
  @Input() saveClickedObservable: Observable<void>;
  @Output() loadingEvent = new EventEmitter<boolean>();
  @Output() serverErrorEvent = new EventEmitter<number>();

  public rosters: Roster[];
  public selectedRosterId: number = null;

  public loadingRosters = true;

  public errorMessage = '';

  private saveClickedSubscription: Subscription;

  constructor(
    public orgConfig: OrganizationConfigService,
    private activeModal: NgbActiveModal,
    private customerService: CustomerService,
    private eventTypeService: EventTypeService,
  ) {}

  ngOnInit() {
    this.saveClickedSubscription = this.saveClickedObservable.subscribe(() => {
      this.handleSave();
    });

    this.loadRosters();
  }

  ngOnDestroy() {
    this.saveClickedSubscription.unsubscribe();
  }

  private handleSave() {
    this.errorMessage = '';

    if (!propExists(this.selectedRosterId)) { return; }

    this.loadingEvent.emit(true);

    this.customerService
      .changeCustomerMembershipRoster(this.membership.id, this.selectedRosterId)
      .then(() => {
        this.savedCallback('Roster successfully changed. It may take up to a minute for all event reservations to be updated.');
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to change this membership roster.';
        } else if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else {
          this.serverErrorEvent.emit(reason.status);
        }
      })
      .finally(() => { this.loadingEvent.emit(false); });
  }

  private loadRosters() {
    this.eventTypeService
      .getRosters(1, 3000, {event_type_id: this.membership.rolling_event_type_id})
      .then(result => {
        this.rosters = result.results.filter(roster => roster.id !== this.membership.rolling_event_type_roster_id);

        if (this.rosters.length > 0) {
          this.selectedRosterId = this.rosters[0].id;
        }
      })
      .catch(reason => {
        this.serverErrorEvent.emit(reason.status);
      })
      .finally(() => { this.loadingRosters = false; });
  }
}
